// Shared by the Exercise Library and the AI proposal (VH-268): one form, one set of options.
// Must match backend MuscleGroupEnum: chest, back, arms, shoulders, legs, core, full_body
export const MUSCLE_GROUPS = ['chest', 'back', 'legs', 'shoulders', 'arms', 'core', 'full_body']

export const DIFFICULTY_LEVELS = [
  { value: 'beginner', color: 'green' },
  { value: 'intermediate', color: 'yellow' },
  { value: 'advanced', color: 'red' },
]

// Exercise types with their default custom metrics
export const EXERCISE_TYPES = [
  { value: 'strength', icon: '💪' },
  { value: 'cardio', icon: '🏃' },
  { value: 'tabata', icon: '⏱️' },
  { value: 'running', icon: '👟' },
  { value: 'cycling', icon: '🚴' },
  { value: 'swimming', icon: '🏊' },
  { value: 'group_class', icon: '👥' },
  { value: 'flexibility', icon: '🧘' },
  { value: 'other', icon: '⚡' },
]

// Default metric templates per exercise type
export const DEFAULT_METRICS_BY_TYPE = {
  tabata: {
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', default: 10, required: true },
    rounds: { label_en: 'Rounds', label_de: 'Runden', type: 'number', default: 8, required: false },
    intensity: { label_en: 'Intensity (1-10)', label_de: 'Intensität (1-10)', type: 'number', default: 7, required: false }
  },
  cardio: {
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', default: 30, required: true },
    distance_km: { label_en: 'Distance (km)', label_de: 'Distanz (km)', type: 'number', unit: 'km', required: false },
    intensity: { label_en: 'Intensity (1-10)', label_de: 'Intensität (1-10)', type: 'number', default: 5, required: false }
  },
  running: {
    distance_km: { label_en: 'Distance (km)', label_de: 'Distanz (km)', type: 'number', unit: 'km', required: true },
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', required: false },
    pace_min_km: { label_en: 'Pace (min/km)', label_de: 'Tempo (min/km)', type: 'number', unit: 'min/km', required: false },
    elevation_m: { label_en: 'Elevation (m)', label_de: 'Höhenmeter (m)', type: 'number', unit: 'm', required: false }
  },
  cycling: {
    distance_km: { label_en: 'Distance (km)', label_de: 'Distanz (km)', type: 'number', unit: 'km', required: true },
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', required: false },
    avg_speed_kmh: { label_en: 'Avg. Speed (km/h)', label_de: 'Durchschn. Geschw. (km/h)', type: 'number', unit: 'km/h', required: false }
  },
  swimming: {
    distance_m: { label_en: 'Distance (m)', label_de: 'Distanz (m)', type: 'number', unit: 'm', required: true },
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', required: false },
    strokes: { label_en: 'Strokes/length', label_de: 'Züge/Bahn', type: 'number', required: false }
  },
  group_class: {
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', default: 60, required: true },
    intensity: { label_en: 'Intensity (1-10)', label_de: 'Intensität (1-10)', type: 'number', default: 7, required: false }
  },
  flexibility: {
    duration_min: { label_en: 'Duration (min)', label_de: 'Dauer (Min)', type: 'number', unit: 'min', default: 15, required: true },
    stretches_count: { label_en: 'Number of stretches', label_de: 'Anzahl Dehnübungen', type: 'number', required: false }
  },
  other: {},  // User defines their own metrics
  strength: {}  // Strength uses sets/reps/weight, not custom metrics
}
